import React from 'react';
import { BookOpen, XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-navy text-white py-16 px-4" data-id="element-319">
      <div className="max-w-3xl mx-auto" data-id="element-320">
        {/* Gas moment opener */}
        <div className="bg-navy-light border-l-4 border-patriot-red rounded-r-xl p-6 mb-12 shadow-lg" data-id="element-321">
          <p className="text-lg md:text-xl text-blue-100 leading-relaxed italic" data-id="element-322">
            "It's late. The house is quiet.
          </p>
          <p className="text-lg md:text-xl text-blue-100 leading-relaxed italic mt-4" data-id="element-323">
            You scroll past another headline about America… and you realize
            something: most people have opinions — but very few know the story
            behind the voices shaping this generation.
          </p>
          <p className="text-lg md:text-xl text-blue-100 leading-relaxed italic mt-4" data-id="element-324">
            If you've ever wondered who Charlie Kirk really is… what shaped him…
            what he believes… and what it cost to build a movement…
          </p>
          <p className="text-lg md:text-xl text-blue-100 leading-relaxed italic mt-4" data-id="element-325">
            <strong className="text-white not-italic" data-id="element-326">
              this is where it finally becomes clear.
            </strong>
            "
          </p>
        </div>

        <div className="text-center mb-12" data-id="element-327">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gold" data-id="element-328">
            Reflections of a young patriot who turned a microphone into a
            movement.
          </h2>
          <div className="w-24 h-1 bg-patriot-red mx-auto mb-8" data-id="element-329"></div>
        </div>

        <div className="prose prose-lg prose-invert mx-auto" data-id="element-330">
          <p className="text-xl leading-relaxed mb-6 font-medium" data-id="element-331">
            Charlie Kirk didn't become a household name overnight. Before the
            headlines, the debates, and the packed rooms… there was a young man
            making a decision: to speak when staying quiet was easier.
          </p>

          <p className="text-gray-300 mb-10" data-id="element-332">
            This isn't "just another political book." It's a tribute-style
            biography—curated, easy to follow, and built to preserve the moments
            and principles people will remember.
          </p>

          <div className="bg-navy-light p-8 rounded-xl border border-blue-900/50 mb-12 shadow-lg" data-id="element-333">
            <div className="flex items-center gap-3 mb-4" data-id="element-334">
              <BookOpen className="text-gold" size={28} data-id="element-335" />
              <h3 className="text-2xl font-bold text-white m-0" data-id="element-336">
                The Missing Story
              </h3>
            </div>
            <p className="text-gray-300 mb-4" data-id="element-337">
              Most people only know the clips, the arguments, and the
              controversy. But the real story—the turning points, the
              sacrifices, the behind-the-scenes moments—rarely gets told in one
              clear place.
            </p>
            <p className="text-gray-300" data-id="element-338">
              This bundle was created to preserve that story in a format you can
              own, revisit, and share—without digging through endless videos and
              scattered timelines.
            </p>
          </div>

          <h3 className="text-2xl font-bold mb-6 text-center" data-id="element-339">
            Why What You Tried Before Didn't Work
          </h3>

          <ul className="space-y-4 mb-8" data-id="element-340">
            {['You watched viral clips… but never got the full story in order.', 'You saw quotes online… but not the context behind them.', 'You searched for interviews… but everything was scattered.', 'You wanted something you could share with family… without sending 20 different links.'].map((text, i) => <li key={i} className="flex items-start gap-3 bg-navy-light/50 p-4 rounded-lg" data-id="element-341">
                <XCircle className="text-patriot-red flex-shrink-0 mt-1" size={20} data-id="element-342" />
                <span className="text-gray-300" data-id="element-343">{text}</span>
              </li>)}
          </ul>

          {/* Bridge lines */}
          <div className="text-center mt-8" data-id="element-344">
            <p className="text-xl text-blue-200 font-medium" data-id="element-345">
              The problem was never a lack of interest.
            </p>
            <p className="text-2xl text-white font-bold mt-2" data-id="element-346">
              The problem was never having the story in one place.
            </p>
          </div>
        </div>
      </div>
    </section>;
}